import { AdMobBanner } from 'expo-ads-admob';
import React from 'react';
import { Platform } from 'react-native';

// https://apps.admob.com/v2/apps/2547835678/adunits/list?pli=1
const AD_UNIT_ID = 'ca-app-pub-7716238237159703/4024568875';

const AdBanner: React.VFC = () => {
	if (Platform.OS === 'web') return null;
	return (
		<AdMobBanner
			bannerSize="smartBannerPortrait"
			adUnitID={AD_UNIT_ID}
			servePersonalizedAds={true}
			onDidFailToReceiveAdWithError={(e) => {
				console.warn(e);
			}}
		/>
	);
};

export default AdBanner;
